import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Tip: store + the tip target (creator / post / live) + optional amount / goal. */
export class TipIntentBuilder extends StoreScopedIntentBuilder {
  /** Tip the creator directly. */
  creator(): this {
    this.root.param('tip_type', 'creator');
    return this;
  }

  /** Tip in the context of a post. */
  post(postId: string): this {
    this.root.param('tip_type', 'post').param('tip_ref', postId);
    return this;
  }

  /** Tip in the context of a livestream. */
  live(streamId: string): this {
    this.root.param('tip_type', 'live').param('tip_ref', streamId);
    return this;
  }

  /** Tip toward a specific tipping goal. */
  goal(goalId: string): this {
    this.root.param('tip_goal', goalId);
    return this;
  }

  /** Pre-fill the tip amount. */
  amount(amount: number): this {
    this.root.param('tip_amount', amount);
    return this;
  }
}
